import React from 'react';
import './SocialButton.css';

export default function SocialButton({ type, label, link, onClick }) {
  return (
    <button className={`social-button ${type}`} onClick={onClick}>
      <div className="icon">
        <img width="48" height="48" src={link} alt={label} />
      </div>
      <span className="label">{label}</span>
    </button>
  );
}
